import { gql } from '@apollo/client'
import { ZONE_HIERARCHY_GLOBAL_SEARCH_RESULT_FRAGMENT } from './ZoneHierarchyGlobalSearchResultFragment'

export const USER_FRAGMENT = gql`
  fragment User on User {
    uuid
    id
    email
    name
    firstName
    lastName
    username
    created
    isStaff
    isSuperuser
    isActive
    customerUserId
    companyName
    mainRole
    roles
    dateRemoved
    supervisor {
      firstName
      lastName
    }
    stores {
      id
    }
    zone {
      ...ZoneHierarchyGlobalSearchResult
    }
  }
  ${ZONE_HIERARCHY_GLOBAL_SEARCH_RESULT_FRAGMENT}
`
